import { render, staticRenderFns } from "./StatisticsGrossProfitExchangeIncomeFilters.vue?vue&type=template&id=9cff60aa&"
import script from "./StatisticsGrossProfitExchangeIncomeFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsGrossProfitExchangeIncomeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports